module.exports = __webpack_public_path__ + "static/image/main/card/image-14.ver2_0_2.png?24f5b37f";